export default "select description\nfrom pg_catalog.pg_description\nwhere objoid = $(id)\n"